export const getParentURL = () => {
  try {
    if (window.opener !== null || window.location != window.parent.location)
      return document.referrer;

    return document.location.href;
  } catch (e) {
    return document.location.href;
  }
};
